module.exports = __webpack_public_path__ + "static/media/logo_main.77779fd5.svg";